// An output tool: the model hands over a brief and the text another model writes from it goes straight to
// the reply, never back to the model. That is why it carries no run: the adapter runs every one of them
// at once after the call, so the main model neither waits for them nor writes the text twice
export function generateTool(config: Extract<PlaybookToolConfig, { type: "generate" }>, index: number): PlaybookTool {
  return {
    name: `generate_${index}`,
    description: `${config.description}. What it writes is sent to the contact right after your message: do not write it yourself or repeat it`,
    parameters: { type: "object", properties: { brief: { type: "string", description: "Everything the writer needs, it sees nothing else" } }, required: ["brief"] },
  }
}
